<template>
    <div class="w3-display-container w3-center w3-margin w3-padding-64">
            <div id="oops-image">
                <img src="/oops.svg" alt="">
            </div>
            <div id="oops-message">
                <h1 class="green-text">
                    <i class="fas fa-user-secret"></i>
                    Oooops.. What's wrong?
                </h1><br><br>
                <div v-if="reason === 'access'">
                    <h1 class="blue-text">Looks like you don't have the right to access this page! </h1>
                </div>
                <div v-if="reason === 'ward'">
                    <h1 class="blue-text">Looks like you don't have any wards connected to you! </h1>
                </div>
                <div v-if="reason === 'other'">
                    <h1 class="blue-text"> Page not found! </h1>
                </div>
                <div v-if="reason === 'unlicensed'">
                    <h1 class="blue-text"> You are not licensed to access this feature! </h1>
                </div>
                <br><br>
                <h3 class="green-text">Please contact your administrator.</h3><br>

                <button @click="goHome"  class="w3-bar-item w3-btn w3-ripple w3-round-medium flow-btn w3-margin flow-blue-bg-color">
                    <i class="fa"><span><b class="w3-text-white">Go to Home page</b></span></i>
                </button></div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Loading from "./common/Loading";
    import il8n from '@/lang/lang'

    let frc = Vue.prototype.$frc;

    export default {
        name: "Problem",
        components: {Loading},
        computed: {
            reason: function() {
                return this.$route.query.reason;
            }
        },
        methods: {
            goHome: function(){
                this.$router.push('/dashboard')
            }
        }
    }
</script>

<style scoped>

</style>